import React from 'react';
import { ArrowRight, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import LocLink from './LocLink';

const EN = {
  eyebrow: 'U.S. Customers',
  headline: 'No surprise tariff charges',
  line1: 'New U.S. import tariffs affecting certain Canadian-made products are now in effect.',
  line2: 'Your U.S. Etsy price already accounts for the current import tariff.',
  line3: 'You will NOT be asked to pay an additional 50% tariff upon delivery.',
  cta: 'Learn more',
  close: 'Dismiss this notice',
};

const FR = {
  eyebrow: 'Clients am\u00e9ricains',
  headline: 'Aucuns frais douaniers surprises',
  line1: 'De nouveaux tarifs d\u2019importation am\u00e9ricains visant certains produits fabriqu\u00e9s au Canada sont maintenant en vigueur.',
  line2: 'Votre prix Etsy am\u00e9ricain tient d\u00e9j\u00e0 compte du tarif d\u2019importation actuel.',
  line3: 'Aucun tarif additionnel de 50 % ne vous sera demand\u00e9 \u00e0 la livraison.',
  cta: 'En savoir plus',
  close: 'Fermer cet avis',
};

const USTariffNotice = ({ className = '', onDismiss }) => {
  const { language } = useLanguage();
  const c = language === 'fr' ? FR : EN;
  return (
    <aside
      data-testid="us-tariff-notice"
      className={`relative rounded-2xl border border-neutral-200 bg-neutral-50 p-6 sm:p-8 ${className}`}
    >
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label={c.close}
          title={c.close}
          data-testid="us-tariff-notice-close"
          className="absolute top-3 right-3 p-2 rounded-full text-neutral-400 hover:text-[#1a1a1a] hover:bg-neutral-200 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      )}
      <div className="flex flex-col md:flex-row md:items-center gap-5 md:gap-8 pr-6 md:pr-8">
        <div className="flex-1">
          <p className="font-mono text-xs uppercase tracking-widest text-neutral-500 mb-2">
            <span aria-hidden="true" className="mr-2">🇺🇸</span>
            {c.eyebrow}
          </p>
          <h3
            data-testid="us-tariff-notice-headline"
            className="font-outfit font-black text-xl sm:text-2xl uppercase tracking-tight text-[#1a1a1a] mb-3"
          >
            {c.headline}
          </h3>
          <p className="font-manrope text-sm text-neutral-600 leading-relaxed">{c.line1}</p>
          <p className="font-manrope text-sm sm:text-base font-bold text-[#1a1a1a] leading-relaxed mt-2">
            {c.line2}
          </p>
          <p className="font-manrope text-sm text-neutral-600 leading-relaxed mt-1">{c.line3}</p>
        </div>
        <LocLink
          to="faq"
          hash="#us-customers"
          data-testid="us-tariff-notice-learn-more"
          className="inline-flex items-center justify-center gap-2 self-start md:self-center whitespace-nowrap bg-[#1a1a1a] hover:bg-[#E31B23] text-white font-outfit font-bold px-6 py-3 rounded-full transition-colors"
        >
          {c.cta}
          <ArrowRight className="w-4 h-4" />
        </LocLink>
      </div>
    </aside>
  );
};

export default USTariffNotice;
